// extracted by mini-css-extract-plugin
export default {"footer-links":"Links_footer-links__Hzomp","title":"Links_title__FtOkq","list":"Links_list__aTP8C","item":"Links_item__MNmEw","link":"Links_link__rO98R"};